import Axios from 'axios'
import React, { Component } from 'react'
import { fmtDollar4, fmtInt } from '../../common/formatters'
import { getUser } from '../../../actions/session'
import { ACCOUNT_DASHBOARD_API } from '../../../config/rest_endpoints'
import Container from '../../common/application_container'
import CustomLoader from '../../common/loader'
import { Notifications } from '../../common/notification'

export default class DashboardTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tableData:[],
            User: getUser(),
            isGetting: false,
        }
    }

    componentDidMount() {
        this.getTable()
    }

    getTable() {
        const {User} = this.state
        this.setState({isGetting:true})
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(`${ACCOUNT_DASHBOARD_API}`,{headers}).then(res=>{
            if(res) {
                console.log(`res`, res)
                var resp = res.data.data
                this.setState({
                    tableData:resp,
                    isGetting:false
                })
            }
        }).catch(err=>{
            Notifications.notify(err,"Failed",'error')
            this.setState({
                isGetting:false
            })
        })
    }

    __renderAccountTable() {
        const { tableData } = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (tableData == null) {
            return nullData
        }
        else {
           return tableData.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td>{row.accountName}</td>
                        <td style={{textAlign:'right'}}>{fmtDollar4(row.balance)}</td>
                        <td style={{textAlign:'right'}}>{fmtDollar4(row.spent)}</td>
                        <td style={{textAlign:'right'}}>{fmtInt(row.sessions)}</td>
                        <td style={{textAlign:'right'}}>{row.sessionsPCT}</td>
                        <td style={{textAlign:'right'}}>{fmtInt(row.CPS)}</td>
                        <td style={{textAlign:'right'}}>{row.CPSPCT}</td>
                        <td style={{textAlign:'right'}}>{row.ASR}</td>
                        <td style={{textAlign:'right'}}>{row.ACD}</td>
                        <td style={{textAlign:'right'}}>{row.SDP}</td>
                        <td style={{textAlign:'right'}}>{fmtDollar4(row.yesterdaySpent)}</td>
                        <td style={{textAlign:'right'}}>{fmtDollar4(row.profit)}</td>
                        <td style={{textAlign:'right'}}>{row.rate}</td>
                        {/* <td>{row.active === false ? <span className="badge badge-danger">Suspend</span> : <span className="badge badge-success">Active</span>}</td>
                        <td><i className="fa fa-edit mr-2" onClick={this.openEditModal.bind(this, row)}></i></td> */}
                    </tr>
                )
            })
        }

    }


    render() {
        const {isGetting} = this.state
        return (
            <Container title="Dashboard" title1="Stats" icon="icon-archive">
                <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',overflow:'hidden'}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                        <h5 style={{fontWeight:'600',fontSize:'14px',color:'#0F172A',margin:0}}>Account Dashboard</h5>
                        <div className="input-group" style={{maxWidth:'300px'}}>
                            <input type="text" className="form-control border-right-0" placeholder="Filter Account" />
                            <span className="input-group-append">
                                <button className="btn search-button" type="button" style={{background:'linear-gradient(135deg, #10B981, #059669)',color:'#fff',border:'none',borderRadius:'0 8px 8px 0'}}><i className="fa fa-search"></i></button>
                            </span>
                        </div>
                    </div>
                    <div style={{overflowX:'auto'}}>
                        <table className="table table-striped" style={{margin:0}}>
                            <thead>
                                <tr>
                                        <th>Account Name</th>
                                        <th style={{textAlign:'right'}}>Balance</th>
                                        <th style={{textAlign:'right'}}>Spent</th>
                                        <th style={{textAlign:'right'}}>Sessions</th>
                                        <th style={{textAlign:'right'}}>Sessions %</th>
                                        <th style={{textAlign:'right'}}>CPS</th>
                                        <th style={{textAlign:'right'}}>CPS %</th>
                                        <th style={{textAlign:'right'}}>ASR</th>
                                        <th style={{textAlign:'right'}}>ACD</th>
                                        <th style={{textAlign:'right'}}>SDP</th>
                                        <th style={{textAlign:'right'}}>Spent Yesterday</th>
                                        <th style={{textAlign:'right'}}>Profit</th>
                                        <th style={{textAlign:'right'}}>Rate</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.__renderAccountTable()}
                                </tbody>
                            </table>
                        </div>
                </div>
            </Container>
        )
    }
}
